import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../common/SEO';

const NotFound = () => {
  return (
    <>
      <SEO 
        title="Page Not Found"
        description="The page you are looking for does not exist or has been moved."
        canonicalUrl="https://clouddigify.com/404"
      />
      <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8 text-center">
          <div>
            <h1 className="text-9xl font-extrabold text-indigo-600">404</h1>
            <h2 className="mt-6 text-3xl font-bold text-gray-900">Page Not Found</h2>
            <p className="mt-2 text-sm text-gray-600">
              The page you are looking for does not exist or has been moved.
            </p>
          </div>
          <div className="mt-8">
            <Link
              to="/"
              className="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700"
            >
              Return to Home
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound; 